import { render, staticRenderFns } from "./AirDrop.vue?vue&type=template&id=f4a23eda"
import script from "./AirDrop.vue?vue&type=script&setup=true&lang=ts"
export * from "./AirDrop.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports